/* eslint-disable import/no-anonymous-default-export */
import { AccountList } from './AccountList';
import { AccountCreate } from './AccountCreate';
import { AccountShow } from './AccountShow';
import { AccountEdit } from './AccountEdit';

export default {
    list: AccountList,
    create: AccountCreate,
    edit: AccountEdit,
    show: AccountShow,
};
